import React, { useCallback } from 'react';
import { ListItem } from '@groupelacentrale/contact-storybook';
import SearchHighlight from './SearchHighlight';

interface Props {
  onClick: (a: string) => void;
  option: string;
  searchCriteria: 'startsWith' | 'anywhere';
  searchValue: string;
  onKeyPress: (e: React.KeyboardEvent) => void | undefined;
  tabIndex: number;
}

const SearchOption: React.FC<Props> = ({ option, onClick, searchCriteria, searchValue, ...props }) => {
  const handleClick = useCallback(() => {
    onClick(option);
  }, [option, onClick]);

  return (
    <ListItem onClick={handleClick} {...props}>
      <SearchHighlight search={searchValue} searchCriteria={searchCriteria} text={option} />
    </ListItem>
  );
};

export default SearchOption;
